import { RootState } from '../../../stores/types';

export default function getUserEmail(state: RootState): string | undefined {
  return state.defaultReducer.user ? state.defaultReducer.user.email : undefined;
}
